import { IconButton, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";

import { TableLayout } from "../../layout/TableLayout";
import { useState } from "react";
import { EditCompany } from "./EditCompany";
import { useDispatch } from "react-redux";
import { selectCompany } from "../../../store/company/companySlice";
import { deleteCompany } from "../../helpers/company";

export const CompaniesListTable = ({ rows, setReloadData }) => {
  const { t } = useTranslation("global");
  const [openEdit, setOpenEdit] = useState(false);
  const dispatch = useDispatch();

  const onEditClick = (e) => {
    dispatch(selectCompany(e.row));
    setOpenEdit(true);
  };
  const onDeleteClick = async (e) => {
    await deleteCompany(
      e,
      t("delete.successMsg"),
      t("delete.errorMsg"),
      t("delete.cancelButton"),
      t("delete.confirmButton"),
      t("delete.deleteConfirm")
    );
    setReloadData((prevState) => !prevState);
  };

  const columns = [
    {
      field: "name",
      headerName: t("companiestable.name"),
      minWidth: 180,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "cif",
      headerName: t("companiestable.cif"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "address",
      headerName: t("companiestable.address"),
      minWidth: 180,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "zipCode",
      headerName: t("companiestable.zipCode"),
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "country",
      headerName: t("companiestable.country"),
      minWidth: 140,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    // {
    //     field: 'iban',
    //     headerName: t('companiestable.iban'),
    //     minWidth: 180,
    //     flex: 1,
    //     align: 'center',
    //     headerAlign: 'center'
    // },
    // {
    //     field: 'swift',
    //     headerName: t('companiestable.swift'),
    //     minWidth: 180,
    //     flex: 1,
    //     align: 'center',
    //     headerAlign: 'center'
    // },
    {
      field: "partner",
      headerName: t("companiestable.partner"),
      minWidth: 220,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "idCrm",
      headerName: t("partnerlist.idCrm"),
      minWidth: 90,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "action",
      headerName: t("partnerlist.columnActions"),
      maxWidth: 90,
      align: "center",
      headerAlign: "center",
      flex: 0,
      sortable: false,
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <IconButton color="secondary" onClick={() => onEditClick(params)}>
              <EditRoundedIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onDeleteClick(params)}>
              <DeleteOutlineRoundedIcon />
            </IconButton>
          </Stack>
        );
      },
    },
  ];

  return (
    <>
      <TableLayout
        rows={rows.map((el) => ({
          ...el,
          partner: `${el?.individual?.name} ${el?.individual?.surnames}`,
          idCrm: el?.individual?.idCrm,
        }))}
        columns={columns}
        title="companies"
      />
      {openEdit && (
        <EditCompany setHidden={setOpenEdit} setReloadData={setReloadData} />
      )}
    </>
  );
};
